(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('naari-sticky-buy')) customElements.define('naari-sticky-buy',class extends HTMLElement {
connectedCallback(){
 this.host=document.getElementById('MainProduct-'+this.dataset.section);
 this.info=document.getElementById('ProductInfo-'+this.dataset.section);
 this.button=this.querySelector('button');this.mainVisible=true;this.footerVisible=false;
 this.abort=new AbortController();this.media=window.matchMedia('(max-width:749px)');
 this.sync=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>{
  const main=this.host.querySelector('button[id^="ProductSubmitButton-"]');
  if(main!==this.main){if(this.main)this.intersection.unobserve(this.main);this.main=main;if(main)this.intersection.observe(main);}
  const price=this.host.querySelector('[id^="price-"] .price');
  const sale=price?.classList.contains('price--on-sale');
  const value=price?.querySelector(sale?'.price__sale .price-item--sale':'.price__regular .price-item--regular');
  this.querySelector('.np-sticky-price').textContent=value?.textContent.trim()||'';
  this.button.disabled=!main||main.disabled||main.getAttribute('aria-disabled')==='true';
  this.button.textContent=main?.querySelector('span')?.textContent.trim()||'Add to cart';
  this.hidden=!this.media.matches||!main||this.mainVisible||this.footerVisible;
 });};
 this.intersection=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.target===this.main)this.mainVisible=e.isIntersecting;else this.footerVisible=e.isIntersecting;});this.sync();},{threshold:0});
 this.footer=document.querySelector('naari-footer,footer.footer');if(this.footer)this.intersection.observe(this.footer);
 this.observer=new MutationObserver(this.sync);if(this.info)this.observer.observe(this.info,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
 this.media.addEventListener('change',this.sync);
 this.button.addEventListener('click',()=>{if(this.main&&!this.main.disabled)this.main.click();},{signal:this.abort.signal});
 this.sync();
}
disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.intersection?.disconnect();this.media?.removeEventListener('change',this.sync);cancelAnimationFrame(this.frame);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naari-countdown"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('naari-countdown'))customElements.define('naari-countdown',class extends HTMLElement{
connectedCallback(){this.end=Date.parse(this.dataset.end);this.clock=this.querySelector('.nt-clock');this.tick=()=>{if(!Number.isFinite(this.end)||!/(Z|[+-]\d{2}:\d{2})$/.test(this.dataset.end)){if(window.Shopify?.designMode){this.hidden=false;this.clock.hidden=true;this.querySelector('[data-note]')?.removeAttribute('hidden');}else this.hidden=true;return;}const remain=Math.max(0,Math.floor((this.end-Date.now())/1000));if(!remain){clearInterval(this.timer);if(this.dataset.hide==='true'){this.hidden=true;}else{this.hidden=false;this.clock.textContent=this.dataset.expired;this.querySelector('.nt-subtitle').hidden=true;this.querySelector('.nt-link')?.setAttribute('hidden','');}return;}this.hidden=false;const parts={days:Math.floor(remain/86400),hours:Math.floor(remain%86400/3600),minutes:Math.floor(remain%3600/60),seconds:remain%60};Object.entries(parts).forEach(([key,value])=>this.querySelector(`[data-part="${key}"]`).textContent=String(value).padStart(2,'0'));};this.timer=setInterval(this.tick,1000);this.tick();}
disconnectedCallback(){clearInterval(this.timer);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naari-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('naari-footer')) {
  customElements.define('naari-footer', class extends HTMLElement {
    connectedCallback() {
      this.media=window.matchMedia('(min-width:750px)');
      this.abort=new AbortController();
      this.menus=Array.from(this.querySelectorAll('.nf-menu'));
      this.sync=()=>this.menus.forEach(menu=>menu.open=this.media.matches);
      this.media.addEventListener('change',this.sync);
      this.menus.forEach(menu=>menu.querySelector('summary').addEventListener('click',e=>{if(this.media.matches)e.preventDefault();},{signal:this.abort.signal}));
      document.addEventListener('shopify:block:select',e=>{ const block=e.target.closest('.nf-menu'); if(block&&this.contains(block))block.open=true; },{signal:this.abort.signal});
      this.sync();
    }
    disconnectedCallback(){this.abort?.abort();this.media?.removeEventListener('change',this.sync);}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naari-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('naari-hero')) {
  customElements.define('naari-hero', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('.nh-track');
      this.slides = Array.from(this.querySelectorAll('.nh-slide'));
      this.dots = Array.from(this.querySelectorAll('.nh-dot'));
      this.index = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelector('.nh-prev')?.addEventListener('click', () => this.go(this.index - 1), {signal});
      this.querySelector('.nh-next')?.addEventListener('click', () => this.go(this.index + 1), {signal});
      this.dots.forEach((dot,i) => dot.addEventListener('click', () => this.go(i), {signal}));
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.update(), 120);
      }, {signal, passive:true});
      this.track.addEventListener('keydown', e => {
        if (e.target !== this.track) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault(); this.go(this.index + (e.key === 'ArrowRight' ? 1 : -1));
        }
      }, {signal});
      document.addEventListener('shopify:block:select', e => {
        const i = this.slides.findIndex(slide => slide.dataset.blockId === e.detail.blockId);
        if (i >= 0) this.go(i, true);
      }, {signal});
      document.addEventListener('shopify:section:reorder', () => this.syncOverlay(), {signal});
      this.resize = new ResizeObserver(() => {
        this.go(this.index, true); this.syncOverlay();
      });
      this.resize.observe(this.track);
      this.header = document.querySelector('.section-header');
      if (this.header) this.resize.observe(this.header);
      this.syncOverlay();
      this.update();
    }
    go(i, instant=false) {
      if (!this.slides.length) return;
      const n = this.slides.length;
      const target = (i+n)%n;
      this.track.scrollTo({left:target*this.track.clientWidth, behavior:instant || this.reduced.matches ? 'auto' : 'smooth'});
    }
    update() {
      this.index = Math.max(0, Math.min(this.slides.length-1, Math.round(this.track.scrollLeft/(this.track.clientWidth || 1))));
      this.dots.forEach((dot,i) => dot.setAttribute('aria-current', String(i===this.index)));
      this.slides.forEach((slide,i) => { slide.inert = i !== this.index; });
      this.querySelector('.nh-status').textContent = `Slide ${this.index+1} of ${this.slides.length}`;
    }
    syncOverlay() {
      const section = this.closest('.shopify-section');
      const main = document.getElementById('MainContent');
      const first = main && Array.from(main.children).find(el => el.classList.contains('shopify-section') && getComputedStyle(el).display !== 'none');
      const enable = this.dataset.overlay === 'true' && first === section && this.header;
      if (enable) {
        if (!this.overlayActive) {
          this.oldMargin = this.header.style.getPropertyValue('margin-bottom');
          this.oldPriority = this.header.style.getPropertyPriority('margin-bottom');
          this.overlayActive = true;
        }
        const height = this.header.getBoundingClientRect().height;
        this.header.style.setProperty('margin-bottom', `-${height}px`);
        this.style.setProperty('--nh-header-space', `${height}px`);
      } else { this.resetOverlay(); }
    }
    resetOverlay() {
      if (this.overlayActive && this.header) {
        if (this.oldMargin) this.header.style.setProperty('margin-bottom',this.oldMargin,this.oldPriority);
        else this.header.style.removeProperty('margin-bottom');
      }
      this.overlayActive = false;
      this.style.setProperty('--nh-header-space','0px');
    }
    disconnectedCallback() {
      this.abort?.abort(); this.resize?.disconnect(); clearTimeout(this.scrollTimer); this.resetOverlay();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naari-reels"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('naari-reels')) {
  customElements.define('naari-reels', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('.nr-track');
      this.cards = Array.from(this.querySelectorAll('.nr-card'));
      this.videos = Array.from(this.querySelectorAll('video'));
      this.prev = this.querySelector('.nr-prev');
      this.next = this.querySelector('.nr-next');
      this.prev.addEventListener('click',()=>this.move(-1),{signal});
      this.next.addEventListener('click',()=>this.move(1),{signal});
      this.track.addEventListener('scroll',()=>this.update(),{signal,passive:true});
      this.track.addEventListener('keydown',e=>{
        if (e.target!==this.track) return;
        if (e.key==='ArrowLeft'||e.key==='ArrowRight') { e.preventDefault(); this.move(e.key==='ArrowRight'?1:-1); }
      },{signal});
      this.cards.forEach(card=>{
        const video=card.querySelector('video');
        if (!video) return;
        card.querySelector('.nr-play').addEventListener('click',async()=>{
          card.querySelector('.nr-error').hidden=true;
          try { await video.play(); }
          catch { card.querySelector('.nr-error').hidden=false; }
        },{signal});
        video.addEventListener('play',()=>{
          this.videos.forEach(other=>{ if (other!==video) other.pause(); });
          card.classList.add('is-playing');
        },{signal});
        video.addEventListener('pause',()=>card.classList.remove('is-playing'),{signal});
        video.addEventListener('ended',()=>card.classList.remove('is-playing'),{signal});
      });
      this.observer=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{ if (!entry.isIntersecting) entry.target.pause(); });
      },{threshold:0.15});
      this.videos.forEach(video=>this.observer.observe(video));
      document.addEventListener('visibilitychange',()=>{ if (document.hidden) this.videos.forEach(video=>video.pause()); },{signal});
      document.addEventListener('shopify:block:select',e=>{
        const card=this.cards.find(card=>card.dataset.blockId===e.detail.blockId);
        if (card) this.track.scrollTo({left:card.offsetLeft-this.cards[0].offsetLeft,behavior:'auto'});
      },{signal});
      this.resize=new ResizeObserver(()=>this.update());
      this.resize.observe(this.track);
      this.update();
    }
    move(direction) {
      const card=this.cards[0]; if (!card) return;
      const gap=parseFloat(getComputedStyle(this.track).gap)||0;
      this.track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    update() {
      this.prev.disabled=this.track.scrollLeft<=2;
      this.next.disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2;
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); this.resize?.disconnect();
      this.videos?.forEach(video=>video.pause());
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
